import { reactive } from "vue";
import { ValidationField } from "./ValidationField";
/**
 * モデルに対する検証処理をサポートします。
 */
export class Validator {
    data;
    constraints;
    errorFields;
    /**
     * コンストラクタ
     * @param data 対象のモデル
     * @param constraints 検証ルール
     */
    constructor(data, constraints) {
        this.data = data;
        this.constraints = constraints;
        this.errorFields = [];
        let self = this;
        for (let key in this.constraints) {
            self[key] = reactive(new ValidationField(key, this.data, this.constraints));
        }
    }
    /** 検証エラーをリセットします。 */
    reset() {
        let self = this;
        for (let key in this.constraints) {
            let field = self[key];
            if (field) {
                field.reset();
            }
        }
        this.errorFields = [];
    }
    /** 検証を実行します。 */
    get error() {
        let self = this;
        let result = false;
        this.errorFields = [];
        for (let key in this.constraints) {
            let field = self[key];
            if (field != null) {
                field.modified = true;
                result = result || field.error;
                if (field.error) {
                    this.errorFields.push(field.key);
                }
            }
        }
        return result;
    }
    /** 検証エラーを処理します。 */
    handle(exception) {
        if (!exception?.data) {
            return false;
        }
        let data = exception.data;
        let code = data.code || "";
        if (code.indexOf("validation") < 0) {
            return false;
        }
        let errors = data.data;
        let self = this;
        for (let key in errors) {
            let field = self[key];
            if (field) {
                field.set(errors[key]);
            }
        }
        return true;
    }
    /** 指定した対象に検証エラーをセットします。 */
    setTo(key, message) {
        let self = this;
        if (!self[key]) {
            return;
        }
        let field = self[key];
        if (field) {
            this.errorFields.push(field.key);
            field.set(message);
        }
    }
    /** 指定した検証エラーをリセットします。 */
    resetTo(key) {
        let self = this;
        if (!self[key]) {
            return;
        }
        let field = self[key];
        if (field) {
            field.reset();
        }
    }
    /** 指定した検証を実行します。 */
    errorTo(key) {
        let self = this;
        if (!self[key]) {
            return false;
        }
        let field = self[key];
        field.reset();
        field.modified = true;
        let result = field.error;
        return result;
    }
}
